<nx-file-upload-size
  [size]="data.file.size"
  [isUploading]="data.file.isUploading"
  [uploadingLabel]="data.field.options?.uploadingLabel ?? data.templateContext.uploadingLabel | translate"
></nx-file-upload-size>
